import type { PagoClienteResponse, QueryPagosDto } from '@aid/shared';

export const PAGOS_TABLE_SCOPE = {
  GLOBAL: 'global',
  CLIENTE: 'cliente',
} as const;

export type PagosTableScope = (typeof PAGOS_TABLE_SCOPE)[keyof typeof PAGOS_TABLE_SCOPE];

export const PAGOS_TABLE_GROUP = {
  NONE: 'none',
  CLIENTE: 'cliente',
  ESTADO: 'estado',
} as const;

export type PagosTableGroupBy = (typeof PAGOS_TABLE_GROUP)[keyof typeof PAGOS_TABLE_GROUP];

export type PagosTableQueryFilters = Omit<QueryPagosDto, 'limit' | 'offset'>;

export interface PagoTableFilterState {
  idCliente: string;
  idEstadoPago?: number;
  idTipoPago?: number;
  idUsuario?: string;
  fechaDesde?: string;
  fechaHasta?: string;
}

export const EMPTY_PAGO_TABLE_FILTERS: PagoTableFilterState = {
  idCliente: '',
};

export interface PagosTableCapabilities {
  showClientFilter: boolean;
  showClientColumn: boolean;
  showUserFilter: boolean;
  showStats: boolean;
  showGrouping: boolean;
  showPaginationSizeChanger: boolean;
  initialPageSize: number;
  compactEmptyState: boolean;
}

export interface PagosTableGroup {
  label: string;
  rows: PagoClienteResponse[];
}

export type PagosTranslate = (key: string, options?: Record<string, unknown>) => string;

export interface PagosTableGlobalProps {
  scope: typeof PAGOS_TABLE_SCOPE.GLOBAL;
}

export interface PagosTableClienteProps {
  scope: typeof PAGOS_TABLE_SCOPE.CLIENTE;
  clienteId: number;
}

export type PagosTableProps = PagosTableGlobalProps | PagosTableClienteProps;

const PAGOS_TABLE_CAPABILITIES = {
  [PAGOS_TABLE_SCOPE.GLOBAL]: {
    showClientFilter: true,
    showClientColumn: true,
    showUserFilter: true,
    showStats: true,
    showGrouping: true,
    showPaginationSizeChanger: true,
    initialPageSize: 20,
    compactEmptyState: false,
  },
  [PAGOS_TABLE_SCOPE.CLIENTE]: {
    showClientFilter: false,
    showClientColumn: false,
    showUserFilter: true, // user requested: the registering-user column + filter
    // also appear on the per-client pagos activity tab.
    showStats: false,
    showGrouping: false,
    showPaginationSizeChanger: true,
    initialPageSize: 10,
    compactEmptyState: true,
  },
} satisfies Record<PagosTableScope, PagosTableCapabilities>;

export function getPagosTableCapabilities(scope: PagosTableScope): PagosTableCapabilities {
  return PAGOS_TABLE_CAPABILITIES[scope];
}
